export const MEMBOT_MAX_USER_MESSAGE_LENGTH = 280;
export const ROMAN_INPUT_SCRIPT_LANGUAGES = ['jp-romaji', 'zh-cn'];

export const UNSUPPORTED_TEXT_TO_SPEECH_LANGUAGES = ['ha', 'yo'];
export const UNSUPPORTED_SPEECH_TO_TEXT_LANGUAGES = ['ha', 'yo'];
